import { render, staticRenderFns } from "./DossierEditQuickCopySpinner.vue?vue&type=template&id=7e5a2308&"
import script from "./DossierEditQuickCopySpinner.vue?vue&type=script&lang=ts&"
export * from "./DossierEditQuickCopySpinner.vue?vue&type=script&lang=ts&"
import style0 from "./DossierEditQuickCopySpinner.vue?vue&type=style&index=0&id=7e5a2308&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e5a2308')) {
      api.createRecord('7e5a2308', component.options)
    } else {
      api.reload('7e5a2308', component.options)
    }
    module.hot.accept("./DossierEditQuickCopySpinner.vue?vue&type=template&id=7e5a2308&", function () {
      api.rerender('7e5a2308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEditQuickCopySpinner.vue"
export default component.exports